import moment from 'moment/moment'

export default {

  /**
   *
   * @param stringData
   * @return {string}
   */
  parseDate (stringData) {
    if (!stringData) {
      return []
    }
    let parseData = stringData.split('T'),
        date      = parseData[0]

    date = date.split('-')

    return date[2] + '.' + date[1] + '.' + date[0]
  },

  /**
   *
   * @param stringData
   * @return {string}
   */
  parseTime (stringData) {
    if (!stringData) {
      return ''
    }
    let parseData = stringData.split('T'),
        time      = parseData[1].split(':'),
        hour      = time[0],
        min       = time[1]

    return hour + ':' + min
  },

  /**
   *
   * @param stringData
   * @return {string}
   */
  parseLocaleDate (stringData) {
    let dateTime = stringData.split(' '),
        day      = dateTime[0],
        month    = dateTime[1],
        year     = dateTime[2]

    if (month.length <= 2) {
      month = '0' + month
    }

    if (day.length <= 2) {
      day = '0' + day
    }

    return day + month + year
  },

  /**
   *
   * @param stringData
   * @return {string}
   */
  parseLocaleTime (stringData) {
    let dateTime = stringData.split(' '),
        time     = dateTime[3].split(':'),
        hour     = time[0],
        min      = time[1]

    if (hour.length <= 1) {
      hour = '0' + hour
    }

    return hour + ':' + min
  },

  /**
   *
   * @param stringData
   * @return {string}
   */
  parseUnifiDate (stringData) {
    let dateTime = stringData.split(' ')

    return dateTime[0]
  },

  /**
   *
   * @param stringData
   * @return {string}
   */
  parseUnifiTime (stringData) {
    let dateTime = stringData.split(' '),
        time     = dateTime[1].split(':'),
        hour     = time[0],
        min      = time[1]

    if (hour.length <= 1) {
      hour = '0' + hour
    }

    return hour + ':' + min
  },

  /**
   *
   * @param year
   * @param month
   * @param day
   * @param hour
   * @param min
   * @param sec
   * @return {Date}
   */
  createDate (
    year = null, month = null, day = null, hour = 0, min = 0, sec = 0) {
    let now = new Date()

    if (!year) {
      year = now.getFullYear()
    }

    if (!month) {
      month = now.getMonth()
    }
    else {
      month = month - 1
    }

    if (!day) {
      day = now.getDate()
    }

    return new Date(year, month, day, hour, min, sec)
  },

  /**
   *
   * @param stringDate
   * @return {*}
   */
  prettyDateToISO (stringDate) {
    if (!stringDate || stringDate === '' || stringDate === ' ') {
      return null
    }

    let splitValue = stringDate.split(' ')

    // zpracovani pouze casu - Timepicker
    if (splitValue.length < 2) {
      time = splitValue[0].split(':')

      return time[0] + ':' + time[1] + ':00'
    }

    // zpracovani celeho datumu vcetne casu - Datetimepicker + Datepicker
    let date  = splitValue[0].split('.'),
        month = date[1].length <= 1 ? '0' + date[1] : date[1],
        day   = date[0].length <= 1 ? '0' + date[0] : date[0],
        time  = splitValue[1].split(':')

    return date[2] + '-' + month + '-' + day + 'T' + time[0] + ':' + time[1] +
      ':00'
  },

  /**
   *
   * @param date {Date}
   */
  dateObjectToISO (date) {
    return moment(date).format('YYYY-MM-DDTHH:mm:ss')
  },

  /**
   *
   * @param date {Date}
   */
  dateObjectToDateTime (date) {
    return moment(date).format('DD. MM. YYYY HH:mm')
  },

  /**
   *
   * @param date {Date}
   */
  dateObjectToTime (date) {
    return moment(date).format('HH:mm:ss')
  },

  /**
   *
   * @param date {Date}
   */
  dateObjectToMMDDYYY (date) {
    return moment(date).format('MM-DD-YYYY')
  }
}
